import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './Dashboard';
import Login from './Login';
import Configuration from './Configuration';

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);

    const checkAuth = () => {
        console.log('[APP] Vérification auth');
        const token = localStorage.getItem('authToken') ||
            localStorage.getItem('token') ||
            localStorage.getItem('access_token');

        console.log('[APP] Token trouvé:', !!token);
        const isAuth = !!token;
        setIsAuthenticated(isAuth);
        setLoading(false);
        return isAuth;
    };

    useEffect(() => {
        console.log('[APP] App monté');
        checkAuth();
    }, []);

    const handleLoginSuccess = () => {
        console.log('[APP] Login success');
        checkAuth();
    };

    const handleLogout = () => {
        console.log('[APP] Logout');
        localStorage.removeItem('authToken');
        localStorage.removeItem('token');
        localStorage.removeItem('prospectys_user');
        setIsAuthenticated(false);
    };

    if (loading) {
        return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>Chargement...</div>;
    }

    console.log('[APP] Render - isAuthenticated:', isAuthenticated);

    return (
        <Router>
            <Routes>
                <Route path="/login" element={<Login onLoginSuccess={handleLoginSuccess} />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/configuration" element={<Configuration />} />
                <Route path="/" element={<Navigate to="/login" replace />} />
            </Routes>
        </Router>
    );
}

export default App;